import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from "react-router-dom";

import { fetchLeadReportsDataForDownload, invalidateLeadsDownloadData } from "actions/leads";

import _ from 'lodash';
import dateformat from "dateformat";
import { Button } from "react-bootstrap";
import cx from 'classnames';

import { convertDatesToTimezone } from 'services/report.service';
import { leadReportHeader } from "constants/leadReportData";

import { CSVLink } from "react-csv";
import { formatDurationWithLabel } from "../../reports/reporthelpers";

import { useReportType } from "../../reports/ReportsProvider";
import styles from '../leadReports.module.scss';

export function LeadSummary(props) {

  const page = useSelector(state => _.get(state, 'storyboards.storyboard.item.page', {}));
  const published = useSelector(state => _.get(state, 'storyboards.storyboard.item.page.published', {}));

  return (
    <div className={styles.summary}>
      <div className={styles.summaryHeading}>
        <div className={styles.left}>
          <h1 className={styles.leadsHeading}>Leads</h1>
          <span className={styles.leadsDescription}>A telescopic view of how your content is performing</span>
        </div>

        <div className={styles.right}>
          <ExportCSV date={props.date} />
          <div className={styles.creator}>
            <span className={styles.heading}>Created by: </span>
            <span className={styles.value}>{_.get(page, 'createdBy.firstName') || ''} {_.get(page, 'createdBy.lastName') || ''}</span>
          </div>

          <div className={styles.updatedInfo}>
            {published && <>
              <div className={styles.published}>
                <span className={styles.heading}>Published: </span>
                <span className={styles.value}>{dateformat(page.lastPublished, 'dd mmm yyyy')}</span>
              </div>
              |
            </>
            }

            <div className={cx({ [styles.modified]: published })}>
              <span className={styles.heading}>Modified: </span>
              <span className={styles.value}>{dateformat(page.modifiedDate, 'dd mmm yyyy')}</span>
            </div>
          </div>
        </div>
      </div>

      
    </div>
  )
}

function ExportCSV(props) {
  const dispatch = useDispatch();

  let { storyboardId } = useParams();
  let downloads = useSelector(state => _.get(state, 'lead.downloads.items'));
  const completed = useSelector(state => _.get(state, 'lead.downloads.completed'));
  const progress = useSelector(state => _.get(state, 'lead.downloads.progress'));
  const [csvData, setCsvData] = useState([]);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const csvLink = useRef();
  const leads = useSelector(state => _.get(state, `storyboards.storyboard.reports.metrics.leads.items`, []));
  const { reportType } = useReportType();

  function updateLeadReportHeader(leads, leadReportHeader) {
    leads.forEach(lead => {
        lead.fields.forEach(field => {
            const exists = field && leadReportHeader.some(header => header.field === field.field);
  
            if (!exists && field && field.uid == null ) {
                leadReportHeader.push({
                    name: field.name,
                    field: field.field,
                    values: field.values,
                    uid: field.uid
                });
            }
        });
    });
  
    return leadReportHeader;
  }
  
  const updatedLeadReportHeader = updateLeadReportHeader(leads, leadReportHeader);

  const headers =  updatedLeadReportHeader && updatedLeadReportHeader.map(header => ({
    label: header.name,
    key: header.field
  }));

  const renderVisitorName = (data) => {
    var name = `${_.get(data, 'firstName') || ''} ${_.get(data, 'lastName') || ''} `;
    return name;
  }

  useEffect(() => {
    if (completed && downloads && downloads.length > 0) {
      var columns = [];
      _.uniqBy(downloads, 'contact.id').map((data, index) => {
        let column = {};
  
        updatedLeadReportHeader.forEach(header => {
          let value = "";
  
          if (header.uid === 'createdDate') {
            value = dateformat(data.contact[header.uid], 'dd mmm yyyy');
          } else if (header.uid === 'lastVisitedDate') {
            value = data.lastVisitedDate ? dateformat(data.lastVisitedDate, 'dd mmm yyyy') : "-";
          } else if (header.uid === 'timeSpent') {
            value = formatDurationWithLabel(data[header.uid]).value;
          }  else if (header.uid === 'completion') {
            value = `${Math.round(data[header.field])} %`;
          } else if (header.uid != null) {
            if (data[header.uid] !== undefined) {
                value = data[header.uid] || "-";
            } else if (data.contact && data.contact[header.uid] !== undefined) {
                value = data.contact[header.uid] || "-";
            }
        }  else {
            const customField = data && data.fields.find(field => field.field === header.field);
            if (customField) {
              if (typeof customField.values === 'boolean') {
                value = customField.values.toString() || "-";
              } else if (Array.isArray(customField.values)) {
                value = customField.values.length > 0 ? customField.values.join(', ') : "-";
              } else {
                value = customField.values || "-";
              }
            } else {
              value = "-";
            }
          }
          column[header.field] = value;
        });
  
        columns[index] = column;
      });

      setCsvData(columns);
    }
  }, [completed, downloads]);

  useEffect(() => {
    if ( csvData && csvData.length == 0) {
      return;
    }

    csvLink.current.link.click();

    return () => {
      dispatch(invalidateLeadsDownloadData());
    }
  }, [csvData]);

  const handleFetchLeadsReport = () => {
    var request = {
      storyboard: storyboardId,
      metricType: "leads",
      reportType,
      ...convertDatesToTimezone(props.date),
    }

    dispatch(fetchLeadReportsDataForDownload(request, 0, 100));
  }

  return (
    <div>
      <Button variant="primary" disabled={progress} onClick={handleFetchLeadsReport} className={styles.download}>
        <span className={styles.name}>{progress ? "Downloading..." : "Download"}</span>
        <i className={cx("cleverstory-download", styles.downloadIcon)} />
      </Button>
      <CSVLink
        ref={csvLink}
        headers={headers}
        data={csvData}
        filename='Reports.csv'
        className='hidden'
      />
    </div>
  )
}